import Swiper from 'swiper/bundle';

new Swiper('.home-slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow: true,
    navigation: {
        nextEl: '.home-slider__nav--next',
        prevEl: '.home-slider__nav--prev',
    },
    pagination: {
        el: '.home-slider__pagination',
        type: 'bullets',
        clickable: true,
    },
});
